import React from 'react';
import { Grid } from 'semantic-ui-react';
import selectors from '@/vocabularies/hooks/selectors';
import MarkdownRender from '@/components/text-editors/MarkdownRender';

const HomePanelCustomContent = ({ compact }) => {
  const { content } = selectors.useHomePanelCustomContent();
  return (
    <Grid.Column className={compact ? 'mb-10 mt-10' : 'border-r'}>
      <MarkdownRender value={content} className="aridhia-home-custom-content" />
    </Grid.Column>
  );
};

export default HomePanelCustomContent;
